import { get } from './client'

/**
 * L'ÉCOSYSTÈME que sert le point d'entrée courant (BBG-149 §8, §11.1.2).
 *
 * Aucun paramètre : le serveur le déduit de l'hôte atteint. Le client ne
 * choisit pas son tenant et ne peut pas le suggérer — c'est exactement
 * l'interdit du §8, « le navigateur ne peut pas imposer arbitrairement un
 * tenant ». Changer de tenant, pour un utilisateur, c'est changer d'adresse.
 */
export interface Ecosysteme {
  /** Identifiant interne immuable : la référence, jamais le nom DNS (§9). */
  id: string
  /** Nom lisible et stable, utilisé dans les URL et les exports. */
  slug: string
  /** Nom d'affichage — l'écran de connexion s'en habille (BBG-33). */
  nom: string
}

/**
 * Résout l'écosystème du point d'entrée. Échoue sur un hôte non enregistré ou
 * non vérifié, avec le message unique du résolveur : « absent », « inconnu » et
 * « pas encore vérifié » ne se distinguent pas de l'extérieur, sinon la route
 * deviendrait un oracle sur l'onboarding des clients.
 */
export function ecosystemeCourant(): Promise<Ecosysteme> {
  return get<Ecosysteme>('/tenant')
}
